/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 * 
 * src/config/companyConfig.ts
 * 
 * Informações institucionais e cadastrais oficiais do Hub Esportivo.
 */

/**
 * CNPJ oficial da empresa.
 * Deixar este campo preparado para receber o número oficial emitido.
 * NUNCA utilizar placeholders arbitrários como '00.000.000/0001-00' publicamente.
 */
export const CNPJ_EMPRESA: string = "68.421.842/0001-50";

export const COMPANY_CONFIG = {
  brandName: "Hub Esportivo",
  legalName: "Hub Esportivo Serviços e Tecnologia Ltda",
  email: "contato@hubesportivo.net.br",
  cnpj: CNPJ_EMPRESA,
  tagline: "Gestão completa para arenas, clubes e espaços esportivos.",
  subtagline: "Centralize quadras, reservas, horários, aulas, treinos, torneios, vendas, PDV e gestão financeira em uma única plataforma.",
  year: new Date().getFullYear(),
} as const;
